import {Link} from "react-router-dom";
import {FacebookIcon, InstagramIcon, YouTubeIcon} from "../icons/SocialIcons.tsx";

interface IProps {
    className?: string;
}

const Footer = ({className}: IProps) => {
    return (
        <div
            className={`grid grid-cols-1 sm:grid-cols-3 px-4 py-5 bg-neutral-900 w-screen md:w-full pb-20 sm:pb-5 ${className}`}>
            <div className={"flex flex-col text-center space-y-2 sm:text-left"}>
                <h3 className={"mb-2 text-neutral-100 tracking-wider"}>BM GO</h3>
                <Link className={"text-neutral-400 hover:text-neutral-300 transition-colors font-light tracking-wide"}
                      to={"/"}>Główna</Link>
                <Link className={"text-neutral-400 hover:text-neutral-300 transition-colors font-light tracking-wide"}
                      to={"/kanaly-tv"}>Kanały
                    TV</Link>
                <Link className={"text-neutral-400 hover:text-neutral-300 transition-colors font-light tracking-wide"}
                      to={"/program-tv"}>Program
                    TV</Link>
            </div>
            <div className={"flex flex-col justify-end space-y-2 text-center sm:text-left mt-2 md:mt-0"}>
                <Link className={"text-neutral-400 hover:text-neutral-300 transition-colors font-light tracking-wide"}
                      to={"/kontakt"}>Kontakt</Link>
                <Link className={"text-neutral-400 hover:text-neutral-300 transition-colors font-light tracking-wide"}
                      to={"/regulamin"}>Regulamin</Link>
                <Link className={"text-neutral-400 hover:text-neutral-300 transition-colors font-light tracking-wide"}
                      to={"/polityka-prywatnosci"}>Polityka prywatności</Link>
            </div>
            <div className={"flex flex-col space-y-5 sm:space-y-2 sm:justify-end justify-end mx-auto sm:mx-0"}>
                <div className={"justify-self-center items-end space-y-4 space-x-2 flex mx-auto sm:mx-0 sm:ml-auto"}>
                    <Link to={"https://www.facebook.com/beskidmedia"} target={"_blank"}
                          className={"ml-auto flex items-center space-x-2 group"}>
                        <FacebookIcon
                            className={"text-white fill-white w-8 h-8 border-2 group-hover:bg-[#1877f2] group-hover:border-transparent rounded-full p-1 transition-all duration-300"}/>
                    </Link>
                    <Link to={"https://www.instagram.com/beskidmedia.pl/"} target={"_blank"}
                          className={"ml-auto flex items-center group relative"}>
                        <InstagramIcon
                            className={"text-white fill-white w-8 h-8 border-2 group-hover:border-transparent rounded-full p-1 transition-all duration-300 z-10"}/>
                        <div
                            className={"absolute left-0 top-0 bg-gradient-to-l from-[#833ab4] via-[#fd1d1d] to-[#fcb045] h-8 w-8 rounded-full opacity-0 group-hover:opacity-100 transition duration-300"}/>
                    </Link>
                    <Link to={"https://www.youtube.com/channel/UC2lBSBB12fSj2JulZ1aFHaA"} target={"_blank"}
                          className={"ml-auto flex items-center space-x-2 group"}>
                        <YouTubeIcon
                            className={"text-white fill-white w-8 h-8 border-2 group-hover:bg-[#ce1312] group-hover:border-transparent rounded-full p-1 transition-all duration-300"}/>
                    </Link>
                </div>
                <h3 className={"text-right text-neutral-400 font-light"}>Copyright © Beskid Media Sp. z o.o.</h3>
                <h3 className={"text-right text-neutral-400 text-sm mt-0 hidden"}>Projekt i realizacja <a
                    href="https://promarch.pl/">Promarch</a></h3>
            </div>
        </div>
    );
};

export default Footer;
